export const RAPORSEM_GET = 'RAPORSEM_GET';
export const RAPORSEMDETAIL_GET = 'RAPORSEMDETAIL_GET';